import { Group, Text } from '@mantine/core';

import { StatRowProps } from './StatRow';

export function TotalRow({ label, value }: StatRowProps) {
  return (
    <Group justify="space-between">
      <Text size="sm" fw={600} c="green">
        {label}
      </Text>
      <Text size="sm" fw={600} c="green">
        {value}
      </Text>
    </Group>
  );
}
